export const UPDATE_PROCESS_STATEMENT_COMMENT_FAILURE = 'UPDATE_PROCESS_STATEMENT_COMMENT_FAILURE';

export const updateProcessStatementCommentFailure = error => ({
    type: UPDATE_PROCESS_STATEMENT_COMMENT_FAILURE,
    payload: error,
    error: true,
});
